import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { Choice } from 'src/app/shared/components/select/choice.model';
import { BasicService } from 'src/app/shared/services/basic.service';

import { TaskListService } from '../services/task-list.service';
import { QueueIdEnum, SortTypesEnum, TaskListModeEnum } from '../shared/enums';
import { TaskListConfiguration } from '../shared/models';
import { SortService } from './task-list-sort.service';

@Component({
  selector: 'app-task-list-sort',
  templateUrl: './task-list-sort.component.html',
  styleUrls: ['./task-list-sort.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskListSortComponent implements OnInit, OnDestroy {
  @Input() taskListConfiguration: TaskListConfiguration;
  @Input() taskListMode: TaskListModeEnum;
  sortTypes: Choice[];
  selectedSortId: number;
  sortControl: FormControl = new FormControl();
  tooltipTxt: string;
  TaskListModeEnum = TaskListModeEnum;

  private subscriptions = new Subscription();

  constructor(
    private basicService: BasicService,
    private sortService: SortService,
    private storage: Storage,
    private taskListService: TaskListService
  ) {}

  ngOnInit() {
    this.tooltipTxt = this.basicService.translate('inbox/order/tooltip');
    const sortTypes = this.sortService.getSortTypes();

    sortTypes.forEach(type => {
      type.label = type.name;
    });

    this.sortTypes = sortTypes as Choice[];

    const isSortDisabled = this.sortService.sortDisabledQueueIds.includes(
      this.taskListConfiguration.queueId as QueueIdEnum
    );

    if (isSortDisabled) {
      this.selectedSortId = SortTypesEnum.mostRecentMessageFirst;
      this.sortControl.disable();
    } else {
      this.selectedSortId = this.taskListConfiguration.sort_type_id;
    }

    this.sortControl.setValue(this.selectedSortId);

    this.subscriptions.add(
      this.sortControl.valueChanges.subscribe((value: number) => {
        this.updateOrder(value);
      })
    );
  }

  updateOrder(sortId: number) {
    this.sortService.setSortId(sortId, this.taskListMode);
    this.storage.set(this.sortService.getStorageKey(this.taskListMode), sortId);
    this.taskListConfiguration.sort_type_id = sortId;
    this.taskListService.reorderTasksBS.next();
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
